import React from 'react';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';

const Highcharts = window.Highcharts;

function CallCenterAreaChart({ data, isTextingEnabled }) {
  const chartDataCalls = data.map((data) => [data.calls]);
  const chartDataLeads = data.map((data) => [data.leads]);
  const chartDataChats = data.map((data) => [data.chats]);
  const chartDataTexts = data.map((data) => [data.texts]);
  const chartDataX = data.map((data) => [data.date]);

  let texts;
  let seriesData;

  if (isTextingEnabled) {
    texts = 'CALLS, CHATS, TEXTS, WEBFORMS BY DAY';
    seriesData = [
      {
        name: 'Calls',
        data: chartDataCalls,
        color: '#106DB6',
        fillOpacity: 0.2,
      },
      {
        name: 'Chats',
        data: chartDataChats,
        color: '#9B7BB7',
        fillOpacity: 0.2,
      },
      {
        name: 'Texts',
        data: chartDataTexts,
        color: '#607D8B',
        fillOpacity: 0.2,
      },
      {
        name: 'WebForms',
        data: chartDataLeads,
        color: '#009999',
        fillOpacity: 0.2,
      },
    ];
  } else {
    texts = 'CALLS BY DAY';
    seriesData = [
      {
        name: 'Calls',
        data: chartDataCalls,
        color: '#106DB6',
        fillOpacity: 0.2,
      },
    ];
  }

  const chartOptions = {
    chart: {
      height: 400,
      type: 'areaspline',
    },
    tooltip: {
      shared: true,
    },
    legend: {
      enabled: true,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    title: {
      text: texts,
      style: {
        fontSize: '14',
      },
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      categories: chartDataX,
    },
    yAxis: {
      title: {
        text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        areaspline: {
          fillOpacity: 0.2,
        },
        enableMouseTracking: false,
      },
    },
    series: seriesData,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          // Make the labels less space demanding on mobile
          chartOptions: {
            xAxis: {
              labels: {
                formatter: function () {
                  return this.value.charAt(0);
                },
              },
            },
            yAxis: {
              labels: {
                align: 'left',
                x: 0,
                y: -2,
              },
              title: {
                text: '',
              },
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
}

CallCenterAreaChart.propTypes = {
  data: PropTypes.array.isRequired,
  isTextingEnabled: PropTypes.bool.isRequired,
};

export default CallCenterAreaChart;
